import(/* webpackMode: "eager" */ "/codebuild/output/src339562424/src/prism-app/prismx-landing/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src339562424/src/prism-app/prismx-landing/components/Analytics.tsx");
